firebird.factory('videoLayoutElementService', [
    '$rootScope',
    '$timeout',
    '$window',
    '$document',
    'logService',
    'attendeeService',
    'attendeeListService',
    'annotationService',
    'localizationService',
    'videoGlobalService',
    'helperService',
    'localStreamManagerService',
    'avDeviceService',
    'executionEnvironmentEnum',
    function (
        $rootScope,
        $timeout,
        $window,
        $document,
        logService,
        attendeeService,
        attendeeListService,
        annotationService,
        localizationService,
        videoGlobalService,
        helperService,
        localStreamManagerService,
        avDeviceService,
        executionEnvironmentEnum
    ) {
        var service = {
            initialize: initialize
        };

        var self, $scope;
        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoLayoutElementService');

        return service;

        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
                $document = videoGlobalService.data.$document;
            }

            self.createVideoElement = createVideoElement;
            self.appendVideoElement = appendVideoElement;
            self.removeVideoElement = removeVideoElement;
            self.getVideoElement = getVideoElement;
            self.enableVideoElement = enableVideoElement;
            self.setAttendeeName = setAttendeeName;

            self.onVideoDoubleClick = onVideoDoubleClick;
            self.onVideoSingleClick = onVideoSingleClick;
            self.onVideoMouseDown = onVideoMouseDown;

            self.isLocalVideoElementShowing = isLocalVideoElementShowing;

            self.getAttendeeAvatar = getAttendeeAvatar;
            self.getAttendeeInitials = getAttendeeInitials;
            self.handleAlertsAndPopupOnVDI = handleAlertsAndPopupOnVDI;
            self.VDIRef = helperService.getVDIRef();
            self.addAvatarNamePlate = addAvatarNamePlate;
            self.reshowAnnotationUiOnVdi = reshowAnnotationUiOnVdi;
        }

        // A video element is laid out within the videoroom-videos div element. It is a nested div-video
        // to display the outbound or inbound video stream in the conference.
        // If id is undefined, then local publisher video element is created, otherwise a remote subscribed
        // video feed is created. The div element contains two attributes - user and enable - the user
        // attribute contains the user id of the remote feed, and the enable attribute indicates whether
        // the element is to be shown in the videos box or not. Note that if even if the remote user is
        // in the conference, the video may be muted, in which case the video element must be present in
        // the videos box but not displayed - so that audio can still be played - if in future we use
        // direct audio from SFU instead of mixed audio from MCU for web users. If is_screen is true,
        // then the screen video class is set on the element, so that it can use the right object-fit
        // for the video element. If self.fileplay is set, then set the fileplay class too.
        // The first parameter enabled is used only if mediapath is 'sfu' to mark the div element attribute,
        // which is used to display or not display the element. It is ignored if mediapath is default.
        // id can be integer or string. The fake_screen parameter is used to mark the DOM element as screen,
        // without any other screen share processing. The screenvideo parameter indicates this is a
        // receive side screen video, and corresponding class is added to the div.
        function createVideoElement(enabled, stream, id, is_screen, orientation, fake_screen, noupdate, screenvideo) {
            logService.log(
                'videoroomCtrl - createVideoElement: id=' + id + (is_screen ? ' (screen)' : '') + ' enabled=' + enabled
            );

            var div = null;
            var created = false;
            var doAttachMediaStream = false;

            if (self.isCompactMode) {
                self.compactRemoveAvatarIfNeeded();
            }

            if (id === undefined) {
                // create local video display element, if not already present.
                if ($window.$('#videoroom-videos div.local').length === 0) {
                    created = true;
                    self.appendVideoElement(id);
                }
                if (stream) {
                    $window.Janus.attachMediaStream($window.$('#videoroom-videos div.local video').get(0), stream);
                    if (
                        self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                        self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware
                    ) {
                        // On VDI, the active stream is used in settings modal and preview. Save it.
                        localStreamManagerService.setCurrentWebcamStreamForVDI(stream);
                    }
                }

                // local video should not playback microphone audio.
                $window.$('#videoroom-videos div.local video').get(0).muted = 'muted';
                div = $window.$('#videoroom-videos div.local').get(0);
            } else {
                // create remote video display element
                if ($window.$('#videoroom-videos div[user="' + id + '"]').length === 0) {
                    created = true;
                    self.appendVideoElement(id);
                }
                if (stream) {
                    if (stream instanceof HTMLElement) {
                        $window.$('#videoroom-videos div[user="' + id + '"] video').remove();
                        $window.$('#videoroom-videos div[user="' + id + '"]').append(stream);
                    } else {
                        // for sfu-fs attach stream here, for sfu attach it in onMediaPathVideoEnabled
                        if (self.mediapath === 'sfu') {
                            doAttachMediaStream = true;
                        } else {
                            logService.log('videoroomCtrl - attachMediaStream (id=' + id + ')');
                            $window.Janus.attachMediaStream(
                                $window.$('#videoroom-videos div[user="' + id + '"] video').get(0),
                                stream
                            );
                        }
                    }
                }
                div = $window.$('#videoroom-videos div[user="' + id + '"]').get(0);

                self.layoutPageCancelResetSrcObject(div);
            }

            if (self.mediapath == 'sfu') {
                self.onMediaPathVideoEnabled(div, enabled, is_screen, 'create', doAttachMediaStream, stream);
            }

            if (self.videoToggle && !!id && self.isVideoTogglePaused(is_screen)) {
                $window.$(div).attr('enable', 'false');

                if (self.layoutPage) {
                    div.isPaused = true;
                }
            }

            // if this is a screen video
            if (is_screen) {
                $window.$(div).addClass('screen');
                if (self.fileplay) {
                    $window.$(div).addClass('fileplay');
                }
            } else if (fake_screen) {
                $window.$(div).addClass('screen');
            }
            if (is_screen || fake_screen) {
                if (self.multishare && screenvideo) {
                    $window.$(div).addClass('secondary');
                } else {
                    $window.$(div).addClass('primary');
                }
            }

            if (orientation) {
                $window.$(div).attr('orientation', orientation);
            }

            // update simulcast receive
            $timeout(function () {
                // so that div.remoteFeed is set
                self.simulcastReason = 'createVideoElement add video';
                $window.$('#videoroom-videos > div:not(.audioonly)').each(function (index, div) {
                    self.setSimulcast(div);
                });
            }, 0);

            if (created) {
                if (!self.layoutPage && id && !is_screen && self.mediapath != 'sfu') {
                    self.setVideoStatsAddRemove(id, div, true);
                }

                if (is_screen && !self.fileplay) {
                    annotationService.attachCanvasAndBorderMaskElement(div);
                }

                // set the attendee name
                self.setAttendeeName(div, id, is_screen);

                // toggle full size on double click.
                div.addEventListener('dblclick', self.onVideoDoubleClick);

                // allow selection and zoom in
                div.addEventListener('mousedown', self.onVideoMouseDown);

                // listen for change in video orientation
                div.querySelector('video').addEventListener('resize', self.onVideoResize);

                // delay animation to after element is added to DOM, not during add.
                $timeout(function () {
                    div.removeAttribute('animate');
                }, 0);
            }

            if (self.layoutLock == 'locked' && !self.isHost) {
                // in case spotlight video was added or removed.
                self.updateLockedSpotlight();
            }

            if (!noupdate) {
                // update the layout.
                if (self.layoutPage && !self.layoutPageData.animateAdd) {
                    self.disableAnimationOnAllVideos(function () {
                        self.updateVideosLayout();
                    });
                } else {
                    self.updateVideosLayout();
                }
            }

            if (!self.VDIRef.showContentsOnTopOfVideo) {
                self.handleAlertsAndPopupOnVDI();
            }
            self.reshowAnnotationUiOnVdi();

            return div;
        }

        // id can be integer or string
        function setAttendeeName(div, id, is_screen) {
            var namePlate = div.querySelector('.name-plate .name');
            if (!id || id == self.attendantId || id == self.getScreenshareIdFromAttendantId(self.attendantId)) {
                var displayText = is_screen
                    ? localizationService.translate('HEADER.SCREEN_SELF_PRESENTATION')
                    : localizationService.translate('COMMON.YOU_TEXT');
                div.setAttribute('displayname', displayText);
                if (namePlate) {
                    namePlate.innerText = displayText;
                }
            } else {
                var list = attendeeListService.getAttendeeList();
                var parts = typeof id === 'string' ? id.split(':') : null; // for testvideos URL param, it can be "id:index"
                if (parts) {
                    id = parts[0];
                }
                if (list) {
                    list.filter(function (attendee) {
                        var aid = attendee.attendantId;
                        if (aid == id) {
                            return true;
                        }
                        if (is_screen) {
                            aid = self.getScreenshareIdFromAttendantId(aid);
                        }
                        if (aid == id) {
                            return true;
                        }
                    }).forEach(function (attendee) {
                        var displayText = is_screen
                            ? localizationService.translate('HEADER.SCREEN_SOMEONE_PRESENTATION', {
                                  person: attendee.screenName
                              })
                            : attendee.screenName;
                        if (parts) {
                            displayText = parts[1] + ': ' + displayText;
                        }
                        div.setAttribute('displayname', displayText);
                        if (namePlate) {
                            namePlate.innerText = displayText;
                        }
                    });
                }
            }
        }

        // called from createVideoElement to add the <div> element in some order if layoutOrder is set;
        // otherwise append, except local at end. if id is undefined, then local video.
        function appendVideoElement(id) {
            var htmlText;

            // get name used for sorting
            var id0 = id; // make a copy that can be modified.
            var is_screen = self.isScreenshareId(id0);
            if (is_screen) {
                id0 = self.getAttendantIdFromScreenshareId(id0);
            }
            if (id0 === undefined) {
                id0 = self.attendantId;
            }

            var videoAvatar = '';
            if (!is_screen) {
                videoAvatar = id ? self.getAttendeeAvatar(id0) : self.getAttendeeAvatar(self.attendantId);
            }

            if (id === undefined) {
                htmlText =
                    '<div class="local" user="' +
                    self.attendantId +
                    '" enable="true" animate="false"><video autoplay playsinline muted="muted"></video>' +
                    videoAvatar +
                    "<div class='name-plate'><span class='paused'>Paused: </span><span class='name' data-private></span></div></div>";
            } else {
                var muted = self.mediapath == 'sfu' && !avDeviceService.isAudioDisconnected() ? '' : ' muted="muted"'; // do not mute if mediapath is 'sfu'
                htmlText =
                    '<div class="remote" user="' +
                    id +
                    '" enable="true" animate="false"><video autoplay' +
                    muted +
                    ' playsinline></video>' +
                    videoAvatar +
                    "<div class='name-plate'><span class='paused'>Paused: </span><span class='name' data-private></span></div></div>";
            }

            var name1;
            if (id0 == self.attendantId) {
                name1 = (self.hasTestLayout && self.testlayoutMyName) || attendeeService.getScreenName();
            } else {
                var attendee = self.findAttendee(id0);
                if (self.hasTestLayout && is_screen) {
                    id0 = ('' + id0).padStart(3, 0);
                }
                name1 = (attendee && attendee.screenName) || '' + id0;
            }
            name1 += ' (' + id0 + ')'; // if two attendees have same name, use id too in ordering.
            if (is_screen) {
                // keep the presentation next to owner's video, if both are present.
                name1 += ' - Presentation';
            }

            name1 = name1.toLowerCase();

            var position = null; // for where the new video is added.

            if (!self.layoutOrder || self.layoutPage) {
                // original code. layoutPage internally uses layoutOrder for display instead of insert in DOM.
                if (id === undefined || $window.$('#videoroom-videos div.local').length === 0) {
                    $window.$('#videoroom-videos').append(htmlText);
                } else {
                    $window.$('#videoroom-videos div.local').before(htmlText);
                    position = -1; // indicates before last one.
                }
            } else {
                // order by id or name.
                var divs = $window.$('#videoroom-videos > div[user]').toArray();
                if (self.layoutOrder == 'id') {
                    // TODO: this won't work with refactorPublisherId.
                    var id1 = id === undefined ? self.attendantId : parseInt(id) || id;
                    var ids = divs.map(function (div) {
                        var user = div.getAttribute('user');
                        return parseInt(user) || user; // if not numeric return as string.
                    });
                    var sorted = ids.slice().sort(function (a, b) {
                        // numeric sort instead of string.
                        return a - b;
                    });
                    if (JSON.stringify(ids) == JSON.stringify(sorted)) {
                        // already sorted. insert in sort order.
                        var index = -1;
                        for (var i = 0; i < ids.length; ++i) {
                            if (id1 < ids[i]) {
                                index = i;
                                break;
                            }
                        }
                        if (index >= 0) {
                            var id2 = '' + ids[index];
                            $window.$('#videoroom-videos > div[user="' + id2 + '"]').before(htmlText);
                            position = index; // at position index.
                        } else {
                            $window.$('#videoroom-videos').append(htmlText);
                        }
                    } else {
                        // not sorted already. append at end.
                        $window.$('#videoroom-videos').append(htmlText);
                    }
                } else {
                    // name, but do not use displayname attribute.
                    var names = divs.map(function (div) {
                        return div.sortName || '';
                    });

                    var sorted1 = names.slice().sort();
                    if (JSON.stringify(names) == JSON.stringify(sorted1)) {
                        // already sorted.
                        var index1 = -1;
                        for (var j = 0; j < names.length; ++j) {
                            if (name1 < names[j]) {
                                index1 = j;
                                break;
                            }
                        }
                        if (index1 >= 0) {
                            $window.$(divs[index1]).before(htmlText);
                            position = index1; // at position index1
                        } else {
                            $window.$('#videoroom-videos').append(htmlText);
                        }
                    } else {
                        // not sorted. append.
                        $window.$('#videoroom-videos').append(htmlText);
                    }
                }
            }

            var div0 = $window.$('#videoroom-videos > div[user="' + (id || self.attendantId) + '"]').get(0);
            if (div0) {
                div0.sortName = name1;
                if ((self.layoutPage || self.layoutPin) && self.mediapath !== 'sfu') {
                    self.addLayoutVideoItem(div0.getAttribute('user'), div0);
                }
                self.onLayoutVideoCountChange();
            }
        }

        function isLocalVideoElementShowing() {
            const item = $window.$('#videoroom-videos div.local').get(0);

            return !!item;
        }

        // When removing a video element, also update the layout. id can be integer or string.
        function removeVideoElement(id, orDiv) {
            logger.log('removeVideoElement', `id=${id} orDiv=${!!orDiv}`);

            let item = null;
            if (orDiv !== undefined) {
                item = $window.$(orDiv);
            } else if (id !== undefined) {
                item = $window.$('#videoroom-videos div[user="' + id + '"]');
            } else {
                item = $window.$('#videoroom-videos div.local');
                if (
                    self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                    self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware
                ) {
                    localStreamManagerService.setCurrentWebcamStreamForVDI(null);
                }
            }

            if (item.length > 0) {
                const fid = item.attr('user');
                self.removeLayoutVideoItem(fid, item.get(0));
                self.stopRemovePosterTimer(fid);
            }

            if (
                (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                    self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware) &&
                item.length > 0
            ) {
                // Update internal active video elements list in janus.js
                $window.Janus.attachMediaStream(item.find('video')[0], null);
            }

            try {
                item[0].removeEventListener('dblclick', self.onVideoDoubleClick);
                item[0].removeEventListener('mousedown', self.onVideoMouseDown);
            } catch (e) {}

            // reduce slow link global counter
            if (item.length > 0 && item.hasClass('remote')) {
                self.checkAndResetGlobalSlowLinkCount(item.get(0));
            }

            self.onLayoutPageRemoving(item.get(0), function () {
                if (item.length > 0) {
                    self.layoutPageCancelResetSrcObject(item.get(0), true); // force reset now
                }

                item.remove();

                if (item.length > 0) {
                    $timeout(function () {
                        // otherwise remove is not counted yet.
                        self.onLayoutVideoCountChange();
                    });
                }

                // if removed element was a full size video, then update the full size
                // video property, and simulcast for all videos.
                if (item.length > 0 && item.get(0) == self.maxvideo) {
                    // TODO: if removed element was screen share, pick another screen share if
                    // available. else set to null.
                    var nextVideoElement = null;
                    if (self.preferredLayout === 'spotlight') {
                        nextVideoElement =
                            $window.$('#videoroom-videos > div.remote.screen').get(0) ||
                            $window.$('#videoroom-videos > div.remote[user]:not(.audioonly)').get(0) ||
                            null;
                    }
                    self.setSpotlightVideo(nextVideoElement);
                }

                self.simulcastReason = 'removeVideoElement remove video';
                // reset simulcast, as number of videos may have changed.
                self.setSimulcastForAllVideos();

                if (self.layoutPage && !self.layoutPageData.animateRemove) {
                    self.disableAnimationOnAllVideos(function () {
                        self.updateVideosLayout();
                    });
                } else {
                    self.updateVideosLayout();
                }
            });
            self.reshowAnnotationUiOnVdi();
        }

        // get video element div object for the given id. id can be integer or string.
        function getVideoElement(id, returnDom) {
            // locate the video element.
            var item = null;
            if (id !== undefined && id != self.attendantId) {
                item = $window.$('#videoroom-videos div[user="' + id + '"]');
            } else {
                item = $window.$('#videoroom-videos div.local');
            }
            if (returnDom) {
                return item.length > 0 ? item.get(0) : null;
            }
            return item;
        }

        // A video element can be audioonly for mediapath=sfu, or make fullsize or normal size.
        // Only non-audioonly video elements are displayed in the videos layout.
        // If fullsize is true or false (not undefined), then it also changes the layout.
        // This is used only when mediapath is 'sfu' to enable or display video display.
        function enableVideoElement(id, value, fullsize) {
            logService.log(
                'videoroomCtrl - enableVideoElement: id=' + id + ' value=' + value + ' fullsize=' + fullsize
            );

            var div = self.getVideoElement(id, true);
            if (div) {
                if (self.mediapath == 'sfu') {
                    self.onMediaPathVideoEnabled(div, value, self.isScreenshareId(id), 'enable', true, null);
                }
                self.onLayoutVideoCountChange();

                // if full size video element is disabled or a full size video element is
                // enabled without full size now, then remove the max video property,
                // update layout.
                if ((!value && div == self.maxvideo) || (value && fullsize === false && div == self.maxvideo)) {
                    self.setSpotlightVideo(null);
                    self.updateVideosLayout();

                    // If a video element is enabled as full size which was not previously
                    // fullsize, then mark this as full size video element.
                } else if (value && fullsize === true && div != self.maxvideo) {
                    self.toggleVideoFullsize(div);

                    // For all other cases, just update the layout, which will show the
                    // enabled video elements.
                } else {
                    self.updateVideosLayout();
                }
            }

            self.simulcastReason = 'enableVideoElement enable/disable video';
            // there may be changes in simulcast
            self.setSimulcastForAllVideos();

            digest();
        }

        // called from mousedown handler to indicate a single click. event is not an Event object, but
        // just an object with valid currentTarget as the div.
        function onVideoSingleClick(event) {
            logService.log('calling onVideoSingleClick...');
            var target = event.currentTarget;

            if ((self.videoToggle || self.videoLoss) && target.getAttribute('paused') == 'true') {
                self.onShowHideOneVideo(target.getAttribute('user'), target);
            } else if (
                self.layoutPage &&
                self.layoutPin &&
                self.layoutPageData.clickAction == 'pin' &&
                self.layoutPageData.layout == 'allhands'
            ) {
                // do video pin on unpin
                self.onToggleLayoutPin(target.getAttribute('user'));
            } else if (
                self.layoutPage &&
                self.layoutPageData.clickAction == 'ignore' &&
                self.layoutPageData.layout == 'allhands'
            ) {
                self.logLayout('ignored click on video'); // do nothing
            } else if (self.layoutTrigger == 'click' || self.layoutTrigger == 'oneclick') {
                if (self.layoutLock == 'locked' && !self.isHost) {
                    // only host can change locked layout.
                    return;
                }

                if (self.layoutTrigger == 'click') {
                    // treat dblclick same as click, so detect dblclick and ignore
                    var now = Date.now();
                    if (self.layoutTriggerLast && self.layoutTriggerLast >= now - 500) {
                        // this is dblclick, ignore it.
                        logService.log('videoroomCtrl - ignoring dblclick');
                        return;
                    }
                    self.layoutTriggerLast = now;
                }

                self.toggleVideoCheck(target);
            } else {
                // original behavior
                var targetId = target.getAttribute('user');
                self.requestKeyFrame(targetId);
            }
            self.reshowAnnotationUiOnVdi();
        }

        // When a video element is double clicked, toggle its full size property.
        function onVideoDoubleClick(event) {
            if (self.layoutLock == 'locked' && !self.isHost) {
                // only host can change locked layout.
                return;
            }

            if (!self.layoutTrigger || self.layoutTrigger == 'dblclick') {
                self.toggleVideoCheck(event.currentTarget);
            }
        }

        // drag and select a rectangle area on a video element.
        // invoke zoomVideoElement or restoreVideoElement when done.
        function onVideoMouseDown(event) {
            if (self.isCompactMode || (event.button !== undefined && event.button !== 0)) {
                // ignore on compact mode, and ignore other clicks other than left click.
                return;
            }
            var target = event.currentTarget;
            if (self.featureFlagsClickAction) {
                var on_mouseup1 = function (event1) {
                    document.removeEventListener('mouseup', on_mouseup1);
                    self.onFeatureFlagsClickAction(target);
                };
                document.addEventListener('mouseup', on_mouseup1);
            } else if (target.zoomData) {
                var on_mouseup = function (event1) {
                    document.removeEventListener('mouseup', on_mouseup);
                    self.restoreVideoElement(target);
                };
                document.addEventListener('mouseup', on_mouseup);
            } else if (
                target.className.match(/\bui-draggable\b/) &&
                !target.className.match(/\bannotation\b/) &&
                (self.layoutTrigger == 'click' || self.layoutTrigger == 'oneclick')
            ) {
                // for picture-in-picture video, detect single click.
                var on_mousemove1 = function (event) {
                    // if mousemove happens, do not trigger single click.
                    document.removeEventListener('mouseup', on_mousemove1);
                    document.removeEventListener('mousemove', on_mousemove1);
                    if (event.type == 'mouseup') {
                        self.onVideoSingleClick({ currentTarget: target });
                    }
                };
                document.addEventListener('mouseup', on_mousemove1);
                document.addEventListener('mousemove', on_mousemove1);
            } else if (!target.className.match(/\bui-draggable\b/) && !target.className.match(/\bannotation\b/)) {
                // do not select if draggable
                var x0 = event.offsetX,
                    y0 = event.offsetY;
                var X0 = event.pageX,
                    Y0 = event.pageY;

                var gh = (target.dragRect = document.createElement('div'));
                gh.className = 'selection';
                gh.style.left = x0 + 'px';
                gh.style.top = y0 + 'px';
                gh.style.width = gh.style.height = '0px';
                target.appendChild(gh);

                // non-spotlight video can be dragged to move. if locked, then only by host.
                // not allowed in allhands view.
                if (
                    self.layoutMove &&
                    target !== self.maxvideo &&
                    (self.layoutLock != 'locked' || self.isHost) &&
                    (!self.layoutPage || self.layoutPageData.layout != 'allhands')
                ) {
                    target.dragTimer = $timeout(function () {
                        if (target.dragRect) {
                            target.removeChild(target.dragRect);
                            delete target.dragRect;

                            target.style.cursor = 'move';
                            var mh = (target.moveRect = document.createElement('div'));
                            mh.className = 'move';
                            mh.style.left = target.offsetLeft + 'px';
                            mh.style.top = target.offsetTop + 'px';
                            mh.style.width = target.offsetWidth + 'px';
                            mh.style.height = target.offsetHeight + 'px';
                            mh.style.cursor = 'move';
                            target.parentNode.appendChild(mh);
                        }
                    }, 500);
                }

                var border = {
                    x: target.offsetLeft,
                    y: target.offsetTop,
                    w: $(target).width(),
                    h: $(target).height()
                };
                var poffset = $(target).parent().offset(); // parent offset wrt pageX/Y
                var on_mousemove = function (event1) {
                    if (target.dragTimer) {
                        $timeout.cancel(target.dragTimer);
                        target.dragTimer = null;
                    }

                    var x = event1.pageX,
                        y = event1.pageY;
                    var w, h, x1, y1;
                    var gh = target.dragRect;
                    var mh = target.moveRect;

                    if (gh) {
                        if (x - border.x - poffset.left < 0) {
                            x = border.x + poffset.left;
                        }
                        if (y - border.y - poffset.top < 0) {
                            y = border.y + poffset.top;
                        }
                        if (x - border.x - poffset.left >= border.w) {
                            x = border.w + border.x + poffset.left;
                        }
                        if (y - border.y - poffset.top >= border.h) {
                            y = border.h + border.y + poffset.top;
                        }

                        x1 = x - X0 + x0;
                        y1 = y - Y0 + y0;
                        w = x0 - x1;
                        h = y0 - y1;
                        if (w < 0) {
                            x1 = x0;
                            w = -w;
                        }
                        if (h < 0) {
                            y1 = y0;
                            h = -h;
                        }
                        gh.style.left = x1 + 'px';
                        gh.style.top = y1 + 'px';
                        gh.style.width = w + 'px';
                        gh.style.height = h + 'px';
                    }

                    if (mh) {
                        var x2 = border.x + x - X0,
                            y2 = border.y + y - Y0;
                        mh.style.left = x2 + 'px';
                        mh.style.top = y2 + 'px';
                    }

                    if (event1.type == 'mouseup') {
                        document.removeEventListener('mouseup', on_mousemove);
                        document.removeEventListener('mousemove', on_mousemove);

                        target.style.cursor = 'pointer';
                        if (gh) {
                            target.removeChild(gh);
                            delete target.dragRect;

                            if (w <= 10 && h <= 10) {
                                self.onVideoSingleClick({ currentTarget: target });
                            } else if (self.VDIRef.allowToZoomVideo) {
                                self.zoomVideoElement(target, { x: x1, y: y1, w: w, h: h });
                            }
                        }
                        if (mh) {
                            var center = {
                                x: mh.offsetLeft + mh.offsetWidth / 2,
                                y: mh.offsetTop + mh.offsetHeight / 2
                            };
                            if (target.parentNode) {
                                target.parentNode.removeChild(mh);
                            }
                            delete target.moveRect;

                            // move the target to new location.
                            var found = null;
                            var children = [].slice.call(
                                document.querySelectorAll('#videoroom-videos > div[enable="true"]:not(.audioonly)')
                            );
                            children.forEach(function (item) {
                                if (
                                    center.x > item.offsetLeft &&
                                    center.x < item.offsetLeft + item.offsetWidth &&
                                    center.y > item.offsetTop &&
                                    center.y < item.offsetTop + item.offsetHeight
                                ) {
                                    found = item;
                                }
                            });
                            if (found && found !== target) {
                                if (target === self.maxvideo) {
                                    logService.log('videoroomCtrl removing max video box');
                                    self.setSpotlightVideo(null);
                                } else if (found === self.maxvideo) {
                                    logService.log('videoroomCtrl moving video box to max video box');
                                    self.setSpotlightVideo(target);
                                } else if (self.layoutPage) {
                                    self.onLayoutPageVideoMove(target, found);
                                } else {
                                    if (target.parentNode) {
                                        var i = children.indexOf(target),
                                            j = children.indexOf(found);
                                        logService.log('videoroomCtrl moving video box from index ' + i + ' to ' + j);
                                        if (i < j) {
                                            // moving forward
                                            if (found.nextSibling) {
                                                target.parentNode.insertBefore(target, found.nextSibling);
                                            } else {
                                                target.parentNode.appendChild(target);
                                            }
                                        } else if (i > j) {
                                            // moving behind
                                            target.parentNode.insertBefore(target, found);
                                        }
                                    }
                                }
                                $timeout(function () {
                                    // do not update layout within mouse handle
                                    self.updateVideosLayout();
                                });
                            }
                        }
                    }
                };

                document.addEventListener('mouseup', on_mousemove);
                document.addEventListener('mousemove', on_mousemove);
            }
        }

        function getAttendeeAvatar(attId) {
            if (!self.layoutPageData.hasAvatar) {
                return '';
            }

            var att = attendeeListService.findAttendee(attId);

            if (att) {
                if (helperService.isDefaultAvatarUrl(att.imageURL)) {
                    //If using default avatar, show initials
                    var initials = att.isPhoneUser
                        ? '<img src="/img/redesign/icons/compact-mode-icons/phone-on-white.svg" />'
                        : self.getAttendeeInitials(att);
                    var colorClass = helperService.convertContactDataToColorClass(att.attendantId, att.screenName);
                    return (
                        '<div class="video-avatar-container" user="' +
                        attId +
                        '" displayname="' +
                        (att.connectivity.pstnState == 'connected'
                            ? 'Phone Caller'
                            : helperService.sanitizeHtml(att.screenName)) +
                        '"><span class="img-circle initials ' +
                        colorClass +
                        '">' +
                        initials +
                        '</span>' +
                        addAvatarNamePlate(att) +
                        '</div>'
                    );
                } else {
                    //Use custom avatar
                    return (
                        '<div class="video-avatar-container" user="' +
                        attId +
                        '" displayname="' +
                        helperService.sanitizeHtml(att.screenName) +
                        '"><img src="' +
                        helperService.sanitizeHtml(att.imageURL) +
                        '" alt="image" class="img-circle"/>' +
                        addAvatarNamePlate(att) +
                        '</div>'
                    );
                }
            } else if (self.testvideos && ('' + attId).indexOf(':') >= 0) {
                var parts = ('' + attId).split(':');
                var color = helperService.convertContactDataToColorClass(attId, '');
                return (
                    '<div class="video-avatar-container" user="' +
                    attId +
                    '" displayname="' +
                    helperService.sanitizeHtml(att.screenName) +
                    '"><span class="img-circle initials ' +
                    color +
                    '">' +
                    parts[1] +
                    '</span></div>'
                );
            } else {
                return '';
            }
        }

        function addAvatarNamePlate(att) {
            if (self.isCompactMode) {
                return (
                    "<div class='avatar-name-plate'><span class='name' data-private>" +
                    (att.connectivity.pstnState == 'connected'
                        ? 'Phone Caller'
                        : helperService.sanitizeHtml(att.screenName)) +
                    '</span></div>'
                );
            } else {
                return '';
            }
        }

        function getAttendeeInitials(att) {
            if (att && att.screenName) {
                return helperService.getInitialsFromName(att.screenName);
            }

            return '';
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function handleAlertsAndPopupOnVDI() {
            // Don't show video on VDI till open modal is closed
            if (
                !$window.Janus?.VDIRef?.showContentsOnTopOfVideo &&
                $window.Janus?.applyVisibilityToVideoElements &&
                $window.Janus?.getModalsOpenInVdiCount() > 0
            ) {
                $window.Janus.applyVisibilityToVideoElements(true);
            }

            // Remove alerts when video is turned on
            var growlAlert = $window.$('.alert').get(0);
            if (growlAlert !== undefined && growlAlert.nodeName === 'DIV') {
                growlAlert.remove();
            }
        }

        function reshowAnnotationUiOnVdi() {
            if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                $rootScope.$broadcast('vdi-reshow-annotation-ui');
            }
        }
    }
]);
